import { type AssetsConfig } from "react-better-html";

import logo from "../assets/logo/logo.svg";
import logoWhite from "../assets/logo/logoWhite.svg";
import profileImageBG from "../assets/logo/profileImageBG.png";
import profileImageBG2 from "../assets/logo/profileImageBG.svg";
import symbol from "../assets/logo/symbol.svg";
import symbolSquare from "../assets/logo/symbolSquare.svg";

import interior01 from "../assets/interior01.webp";

export const assets: Partial<AssetsConfig> = {
   logo,
   logoWhite,
   profileImageBG,
   profileImageBG2,
   symbol,
   symbolSquare,

   interior01,
};
